import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Discussion } from '@core/models/discussion.model';
import { Message } from '@core/models/message.model';
import { User } from '@core/models/user.model';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';

@Injectable()
export class DiscussionService {
  constructor(private httpClient: HttpClient) {}

  discussionsForExam(examId: number): Observable<Discussion[]> {
    const route = `${environment.examInfoBackend}/exam_requests/${examId}/discussions`;
    return this.httpClient.get<Discussion[]>(route);
  }

  createDiscussion(
    examId: number,
    otherUserId: number,
    authorizationId: number | null = null,
  ): Observable<Discussion> {
    const body: any = {};
    if (authorizationId) {
      body.authorization_id = authorizationId;
    }
    const route = `${environment.examInfoBackend}/exam_requests/${examId}/discussions/create_with/${otherUserId}`;
    return this.httpClient.post<Discussion>(route, body);
  }

  getDiscussion(examId: number, discussionId: number): Observable<Discussion> {
    const route = `${environment.examInfoBackend}/exam_requests/${examId}/discussions/${discussionId}`;
    return this.httpClient.get<Discussion>(route);
  }

  clearNonReads(examId: number, discussionId: number): Observable<any> {
    const route = `${environment.examInfoBackend}/exam_requests/${examId}/discussions/${discussionId}/clear_non_reads`;
    return this.httpClient.post<any>(route, {});
  }

  addMessage(examId: number, discussionId: number, message: Message) {
    const route = `${environment.examInfoBackend}/exam_requests/${examId}/discussions/${discussionId}/add_message`;
    return this.httpClient.post<Discussion>(route, message);
  }

  addAnnotationMessage(
    examId: number,
    discussionId: number,
    annotationId: number,
  ) {
    const route = `${environment.examInfoBackend}/exam_requests/${examId}/discussions/${discussionId}/add_annotation/${annotationId}`;
    return this.httpClient.post<Discussion>(route, {});
  }

  getDoctors(): Observable<User[]> {
    const route = `${environment.examInfoBackend}/doctors`;
    return this.httpClient.get<User[]>(route);
  }

  getDoctorsAdminsAndExternals(examId: number): Observable<User[]> {
    const route = `${environment.examInfoBackend}/doctors_admins_and_externals`;
    return this.httpClient.get<User[]>(route, { params: { exam_id: examId } });
  }
}
